import * as React from "react"
import type { SVGProps } from "react"
const SvgPinRemove = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M14 5.29h-4v2.17L7.25 4.71a1 1 0 0 1-.19-.28 1 1 0 0 1-.06-.3 1 1 0 0 1 .23-.58.8.8 0 0 1 .6-.27H16q.42 0 .71.3.3.28.29.7a.6.6 0 0 1-.36.57 2 2 0 0 0-.64.43v6q0 .43-.29.72a1 1 0 0 1-.71.28 1 1 0 0 1-.71-.28 1 1 0 0 1-.29-.72zm-3 17v-6H7.4q-.63 0-1-.44a1.5 1.5 0 0 1-.37-.99q0-.27.1-.55.12-.27.37-.52l1.5-1.5v-1.15L2.1 5.19a1 1 0 0 1-.29-.7 1 1 0 0 1 .29-.7 1 1 0 0 1 .7-.28q.42 0 .7.28l16.98 16.97q.3.3.28.71a1 1 0 0 1-.31.72q-.3.27-.7.28a1 1 0 0 1-.7-.28l-5.9-5.9H13v6q0 .43-.29.7a1 1 0 0 1-.71.3 1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7m-2.15-8h2.3L10 13.14z" />
  </svg>
)
export default SvgPinRemove
